var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "main",
    { staticClass: "booking" },
    [
      _vm.getBookingTypesStatus == "success"
        ? _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: !_vm.initialized || !_vm.openTime || !_vm.closeTime,
                  expression: "!initialized || !openTime || !closeTime"
                }
              ],
              attrs: {
                novalidate: "true",
                inline: true,
                "label-width": "10em",
                "label-position": "top",
                size: _vm.formSize
              }
            },
            [
              _vm.settings.default_players_type == "combined"
                ? _c(
                    "el-form-item",
                    { attrs: { label: "Game Type" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { value: _vm.bookingTypeId },
                          on: { input: _vm.setBookingTypeId }
                        },
                        _vm._l(_vm.bookingTypes, function(bt) {
                          return _c("el-option", {
                            key: bt.id,
                            attrs: { label: bt.name, value: bt.id }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "Pick a date" } },
                [
                  !_vm.isMobile
                    ? _c("el-date-picker", {
                        attrs: {
                          "picker-options": _vm.pickerOptions,
                          "value-format": "yyyy-MM-dd",
                          value: _vm.date,
                          type: "date",
                          editable: false,
                          placeholder: "Pick a day"
                        },
                        on: { input: _vm.setDate }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isMobile
                    ? _c("el-input", {
                        staticClass: "mobile-date",
                        attrs: {
                          type: "text",
                          readonly: true,
                          value: _vm.date,
                          "prefix-icon": "el-icon-date"
                        },
                        on: { focus: _vm.openMobileDatePicker }
                      })
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "Pick a time" } },
                [
                  _vm.isMobile
                    ? _c("mt-datetime-picker", {
                        ref: "datePicker",
                        attrs: {
                          type: "date",
                          confirmText: "Confirm",
                          cancelText: "Cancel",
                          startDate: _vm.today,
                          startHour: _vm.minHour,
                          endHour: _vm.maxHour
                        },
                        on: {
                          confirm: _vm.confirmMobileDate,
                          cancel: _vm.closeMobileDatePicker
                        },
                        model: {
                          value: _vm.mobileDateTime,
                          callback: function($$v) {
                            _vm.mobileDateTime = $$v
                          },
                          expression: "mobileDateTime"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.openTime
                    ? _c("el-time-select", {
                        attrs: {
                          value: _vm.time,
                          editable: false,
                          "picker-options": {
                            start: _vm.timeForComponent(_vm.openTime),
                            step: _vm.timeStep,
                            end: _vm.timeForComponent(_vm.closeTime)
                          },
                          placeholder: "Select time"
                        },
                        on: { input: _vm.setTime }
                      })
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _vm.settings.default_players_type == "adults_and_juniors"
                ? _c(
                    "el-form-item",
                    { attrs: { label: "Adults" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { value: _vm.adults },
                          on: { input: _vm.setAdults }
                        },
                        _vm._l(31, function(n, i) {
                          return _c("el-option", {
                            key: i,
                            attrs: { label: i, value: i }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.settings.default_players_type == "adults_and_juniors"
                ? _c(
                    "el-form-item",
                    { attrs: { label: "Juniors (under 18)" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { value: _vm.juniors },
                          on: { input: _vm.setJuniors }
                        },
                        _vm._l(31, function(n, i) {
                          return _c("el-option", {
                            key: i,
                            attrs: { label: i, value: i }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.settings.default_players_type == "combined"
                ? _c(
                    "el-form-item",
                    { attrs: { label: "Players" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { value: _vm.adults },
                          on: { input: _vm.setAdults }
                        },
                        _vm._l(_vm.playerRange, function(i) {
                          return _c("el-option", {
                            key: i,
                            attrs: { label: i, value: i }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.timedGame
                ? _c(
                    "el-form-item",
                    { attrs: { label: "Number of games" } },
                    [
                      _c("el-input-number", {
                        attrs: {
                          value: _vm.games,
                          min: _vm.minGames,
                          max: _vm.maxGames
                        },
                        on: { input: _vm.setGames }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.timedGame &&
              _vm.bookingType &&
              _vm.bookingType.duration == null
                ? _c(
                    "el-form-item",
                    { attrs: { label: "Duration" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { value: _vm.duration },
                          on: { input: _vm.setDuration }
                        },
                        _vm._l([15, 30, 45, 60], function(i) {
                          return _c("el-option", {
                            key: i,
                            attrs: { label: i, value: i }
                          })
                        }),
                        1
                      ),
                      _vm._v("\n      minutes\n    ")
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: { label: "Promo code", error: _vm.errors.promo_code }
                },
                [
                  _c(
                    "el-input",
                    {
                      attrs: {
                        disabled:
                          _vm.promoCode != null && _vm.promoCode.length > 0
                      },
                      model: {
                        value: _vm.promoCodeValue,
                        callback: function($$v) {
                          _vm.promoCodeValue = $$v
                        },
                        expression: "promoCodeValue"
                      }
                    },
                    [
                      _vm.promoCodeValue && !_vm.promoCode
                        ? _c(
                            "el-button",
                            {
                              attrs: { slot: "append", type: "primary" },
                              on: { click: _vm.applyPromoCode },
                              slot: "append"
                            },
                            [_vm._v("Apply")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.promoCode
                        ? _c(
                            "el-button",
                            {
                              attrs: { slot: "append", type: "primary" },
                              on: { click: _vm.removePromoCode },
                              slot: "append"
                            },
                            [_vm._v("Remove")]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.allScenarios && _vm.bookingTypes.length == 0
                ? _c(
                    "el-form-item",
                    { attrs: { label: "Filter by deal" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: "Select a deal",
                            value:
                              _vm.scenarioFilter.length && _vm.scenarioFilter[0]
                                ? _vm.scenarioFilter[0]
                                : null
                          },
                          on: { input: _vm.setScenarioFilter }
                        },
                        [
                          _c("el-option", {
                            key: "0",
                            attrs: { label: "Any", value: null }
                          }),
                          _vm._v(" "),
                          _vm._l(_vm.allScenarios, function(s) {
                            return _c("el-option", {
                              key: s.id,
                              attrs: { label: s.name, value: s.id }
                            })
                          })
                        ],
                        2
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.initialized && !_vm.errors.promo_code && _vm.adults + _vm.juniors > 0
        ? _c("scenarios", {
            ref: "scenarios",
            attrs: {
              scenarioFilter: _vm.scenarioFilter,
              date: _vm.date,
              time: _vm.time,
              adults: _vm.adults,
              juniors: _vm.juniors,
              games: _vm.games,
              duration: _vm.duration,
              promoCode: _vm.promoCode,
              timedGame: _vm.timedGame,
              bookingType: _vm.bookingType
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }